import type { FC } from 'react';

import { IntegerField } from 'components/forms/fields/IntegerField';

import { InlineFiltersMeasurementWrapper } from './InlineFilters.MeasurementWrapper';
import { InlineFilterSectionProps, InlineFiltersSection } from './InlineFilters.Section';

type Props = Partial<InlineFilterSectionProps> & {
    name: string;
    value?: number;
    formattedValue?: string;
    label: string;
    placeholder?: string;
    leftSection?: React.ReactNode;
    active: boolean;
};

const InlineFiltersNumber: FC<Props> = ({ name, value, formattedValue, label, placeholder, leftSection, ...props }) => {
    return (
        <InlineFiltersSection
            {...props}
            body={
                <InlineFiltersMeasurementWrapper placeholder={label} label={formattedValue || value?.toString() || ''}>
                    <IntegerField
                        leftSection={leftSection}
                        hideControls
                        name={name}
                        size="xs"
                        min={1}
                        placeholder={placeholder}
                    />
                </InlineFiltersMeasurementWrapper>
            }
        />
    );
};

export { InlineFiltersNumber };
